import Joi from 'joi';

export class MicroFrontendService {
  public static validateUrl = (url: any): boolean => {
    const URL_SCHEMA_VALIDATION = Joi.string()
      .trim()
      .uri({ scheme: ['http', 'https'] })
      .required();

    try {
      Joi.attempt(url, URL_SCHEMA_VALIDATION);
      // biome-ignore lint/correctness/noUnusedVariables: ignored using `--suppress`
    } catch (error) {
      return false;
    }

    return true;
  };
}
